import { render, staticRenderFns } from "./EgresoCategoriaCreate.vue?vue&type=template&id=4871bd1f&scoped=true&"
import script from "./EgresoCategoriaCreate.vue?vue&type=script&lang=js&"
export * from "./EgresoCategoriaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4871bd1f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
